import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  FormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FileUploadComponent } from '../../util/upload/file-upload.component';
import * as _ from 'lodash';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { DynamicFormEmbedComponent } from '../../util/dynamic-form-embed/dynamic-form-embed.component';
import {
  DynamicFormConfigurationView,
  DynamicFormValues,
  DynamicFormView,
  EDynamicFormInputType,
  EDynamicFormSource,
} from '../../models/DynamicFormView';
import { VendorFormService } from '../../service/vendor.service';
import { UtilityService } from '../../service/utility.service';
import { NotificationService } from '../../service/notification.service';
import { LoadingService } from '../../service/loading.service';
import Swal from 'sweetalert2';
import {
  Country,
  UsState,
  vendorAddressAndContactType,
} from '../../models/Vendor';
import { routingNumberValidator } from '../../util/validator/routing-number.validator';
import { dynamicZipCodeValidator } from '../../util/validator/zip-code.validator';
import { ZipCodeService } from '../../service/zip-code.service';
import { RegistrationHelpComponent } from '../../chat/registration-help/registration-help.component';
import { PortalFeatureDirective } from '../../directives/portal-feature.directive';
import {
  clearSessionKeepingBrowserContext,
  PENDING_REGISTRATION_ID_KEY,
  PENDING_REGISTRATION_TOKEN_KEY,
} from '../../util/session-keys';
import { DocumentView } from '../../models/form/DocumentView';
import { ConfigService } from '../../service/config.service';

@Component({
  selector: 'app-vendor-registration',
  standalone: true,
  imports: [
    NgxMaskDirective,
    DynamicFormEmbedComponent,
    FormsModule,
    FileUploadComponent,
    CommonModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    RegistrationHelpComponent,
    PortalFeatureDirective,
  ],
  templateUrl: './vendor-registration.component.html',
  styleUrls: ['./vendor-registration.component.css'],
})
export class VendorRegistrationComponent implements OnInit, AfterViewInit {
  form: FormGroup;
  contactForm: FormGroup;
  submitted = false;
  files: any[] = [];
  uploadedFiles: File[] = [];
  submittedContent = false;
  Contacts: any[] = [];
  isDocumentDeleted = false;
  deletedDocumentIds = [];
  showBank: boolean;
  achEnabled = true;
  isEditing!: Boolean;
  item: any;
  readonly id!: string;
  readonly clientId!: string;

  additionaFields!: DynamicFormView;
  sourceId: number = EDynamicFormSource.VendorForm;
  prefixLabel = '';
  vendorAddress: FormArray;
  VendorAddresses = [];
  addressAndContactTypes = [
    { id: 1, name: 'Purchasing' },
    { id: 2, name: 'Remittance' },
  ];
  vendorAddressAndContactType = vendorAddressAndContactType;
  contacts = [
    { contactType: vendorAddressAndContactType.Purchasing },
    { contactType: vendorAddressAndContactType.Remittance },
  ];
  usStates: UsState[] = [];
  countries: Country[] = [];
  isCollapsed = true;
  editMode = false;
  showEditBanner = false;
  pendingRegistration: any = null;
  existingDocuments: DocumentView[] = [];
  removedDocumentIds: string[] = [];
  private editFormId: string | null = null;
  private editToken: string | null = null;
  constructor(
    private formBuilder: FormBuilder,
    public utilityService: UtilityService,
    private notificationService: NotificationService,
    private vendorFormService: VendorFormService,
    private spinner: LoadingService,
    private cdr: ChangeDetectorRef,
    private zipCodeService: ZipCodeService,
    private router: Router,
    private configService: ConfigService,
  ) {
    this.usStates = this.utilityService.getUsState();
    this.countries = this.utilityService.getCountries();
    this.contactForm = this.formBuilder.group({
      id: ['00000000-0000-0000-0000-000000000000'],
      contactName: [null, Validators.required],
      phone: [null, Validators.required],
      emailAddress: [null, [Validators.email, Validators.required]],
      contactType: [null, Validators.required],
    });

    this.form = this.formBuilder.group({
      id: ['00000000-0000-0000-0000-000000000000'],
      Name: [null, Validators.required],
      LegalName: [null, Validators.required],
      Address: [null, [Validators.maxLength(50), Validators.required]],
      AddressLine2: [null, Validators.maxLength(50)],
      isInternational: [false],
      City: [null, [Validators.maxLength(30), Validators.required]],
      State: ['AL', [Validators.required]],
      country: ['USA'],
      ZipCode: [null, [Validators.maxLength(10), Validators.required]],
      Description: [null],
      W9Status: ['Yes'],
      FutureBidStatus: [null],
      W9StatusReason: [null],
      VendorType: [null],
      TradeBusinessEngaged: [null],
      ReceivesRentOrRoyaltyIncome: [null],
      ApplicableTaxIdentificationNumber: [null, [Validators.required]],
      SocialSecurityNumber: [null],
      EmployerIdentificationNumber: [null],
      Form1099Applicable: ['0'],
      paymentType: [''],
      deliveryMethod: ['Email', Validators.required],
      Form1099ApplicableOther: [null],
      IsIncorporated: [null],
      corporationType: [null],
      VendorDepartments: [null],
      OfferEarlyPaymentDiscount: [null],
      EarlyPaymentDiscountDescription: [null],
      Contacts: new FormArray([]),
      PayViaACH: [null, [Validators.required]],
      BankName: [null],
      BankRoutingNumber: [null],
      BankAccountNumber: [null],
      BankAccountType: [null],
      BankAccountClass: [null],
      DigitalCheckEmailAddress: [null],
      ProvidesMerchandiseOrUtilities: [false],
      MinorityBusinessEnterprise: [false],
      requestedBy: ['system'],
      vendorW9File: new FormControl(null),
      voidedCheckFile: new FormControl(null),
      projectAgreement: new FormControl(null),
      attachments: new FormArray([]),
      MedicalLegalServicesStatus: [null],
      ExistingBusinessRelation: [null],
      isDraft: [true],
      additionalFieldValues: [null],
      vendorId: [null],
      vendorAddresses: this.formBuilder.array([]),
      isDuplicate: [false],
    });
    this.form.get('PayViaACH')?.valueChanges.subscribe((val) => {
      this.form.get('BankName')?.clearValidators();
      this.form.get('BankRoutingNumber')?.clearValidators();
      this.form.get('BankAccountNumber')?.clearValidators();
      this.form.get('BankAccountType')?.clearValidators();
      this.form.get('BankAccountClass')?.clearValidators();
      this.form.get('voidedCheckFile')?.clearValidators();

      if (val === 'true') {
        this.showBank = true;
        this.form
          .get('BankName')
          ?.setValidators([Validators.maxLength(50), Validators.required]);
        this.form
          .get('BankRoutingNumber')
          ?.setValidators([
            Validators.maxLength(25),
            Validators.required,
            routingNumberValidator(),
          ]);
        this.form
          .get('BankAccountNumber')
          ?.setValidators([Validators.maxLength(25), Validators.required]);
        this.form.get('BankAccountType')?.setValidators([Validators.required]);
        this.form.get('BankAccountClass')?.setValidators([Validators.required]);
        if (!this.editMode) {
          this.form.get('voidedCheckFile')?.setValidators([Validators.required]);
        }
      } else {
        this.showBank = false;
        this.form.get('BankName')?.setValue(null);
        this.form.get('BankRoutingNumber')?.setValue(null);
        this.form.get('BankAccountNumber')?.setValue(null);
        this.form.get('BankAccountType')?.setValue(null);
        this.form.get('BankAccountClass')?.setValue(null);
        this.form.get('voidedCheckFile')?.setValue(null);
      }
      this.form.get('BankName')?.updateValueAndValidity();
      this.form.get('BankRoutingNumber')?.updateValueAndValidity();
      this.form.get('BankAccountNumber')?.updateValueAndValidity();
      this.form.get('BankAccountType')?.updateValueAndValidity();
      this.form.get('BankAccountClass')?.updateValueAndValidity();
      this.form.get('voidedCheckFile')?.updateValueAndValidity();
    });
    this.vendorAddress = this.form.get('vendorAddresses') as FormArray;
    if (!this.id) {
      this.addDefaultAddresses();
    }
    this.form.get('W9Status')?.valueChanges.subscribe((val) => {
      if (val === 'Yes') {
        this.form.get('SocialSecurityNumber')?.clearValidators();
        this.form.get('EmployerIdentificationNumber')?.clearValidators();
        this.form.get('ApplicableTaxIdentificationNumber')?.clearValidators();
      } else {
        this.form
          .get('ApplicableTaxIdentificationNumber')
          ?.setValidators([Validators.required]);
      }
      this.form
        .get('ApplicableTaxIdentificationNumber')
        ?.updateValueAndValidity();
    });
  }

  setVendorW9FileValidator(status: string) {
    const vendorW9FileControl = this.form.get('vendorW9File');
    const W9StatusReasonControl = this.form.get('W9StatusReason');

    if (this.editMode) {
      vendorW9FileControl?.clearValidators();
      vendorW9FileControl?.updateValueAndValidity();
      W9StatusReasonControl?.updateValueAndValidity();
      return;
    }

    if (status === 'Yes') {
      vendorW9FileControl?.setValidators([Validators.required]);
      W9StatusReasonControl?.clearValidators();
    } else if (status === 'No') {
      W9StatusReasonControl?.setValidators([Validators.required]);
      vendorW9FileControl?.clearValidators();
    } else {
      vendorW9FileControl?.clearValidators();
      W9StatusReasonControl?.clearValidators();
    }

    vendorW9FileControl?.updateValueAndValidity();
    W9StatusReasonControl?.updateValueAndValidity();
  }

  ngOnInit() {
    this.setVendorW9FileValidator(this.form.get('W9Status')!.value);
    this.form.get('W9Status')!.valueChanges.subscribe((status) => {
      this.setVendorW9FileValidator(status);
    });
    this.configService.whenResolved().subscribe((config) => {
      this.achEnabled = this.configService.isFeatureEnabled(config.achEnabled);
      if (!this.achEnabled) {
        const payViaAch = this.form.get('PayViaACH');
        payViaAch?.clearValidators();
        payViaAch?.setValue('false');
        payViaAch?.updateValueAndValidity();
      }
    });
    this.checkPendingRegistration();
  }

  checkPendingRegistration() {
    const pendingId = localStorage.getItem(PENDING_REGISTRATION_ID_KEY);
    const pendingToken = localStorage.getItem(PENDING_REGISTRATION_TOKEN_KEY);
    if (!pendingId || !pendingToken) return;

    this.vendorFormService.getSubmittedForm(pendingId, pendingToken).subscribe({
      next: (data: any) => {
        this.pendingRegistration = data;
        this.showEditBanner = true;
      },
      error: (err: any) => {
        if (err?.status === 409) {
          // Approved while the vendor was away: tell them instead of failing silently.
          this.handleRegistrationApproved(err?.error?.message);
          return;
        }
        if (err?.status === 400 || err?.status === 404 || err?.status === 500) {
          // Denied-and-locked, or no longer valid — the edit window is over.
          this.clearPendingRegistration();
        }
      },
    });
  }

  startEditingSubmitted() {
    if (!this.pendingRegistration) return;
    this.editMode = true;
    this.showEditBanner = false;
    this.editFormId = localStorage.getItem(PENDING_REGISTRATION_ID_KEY);
    this.editToken = localStorage.getItem(PENDING_REGISTRATION_TOKEN_KEY);
    this.existingDocuments = this.pendingRegistration.documents || [];
    this.removedDocumentIds = [];
    this.prefillFromSubmitted(this.pendingRegistration);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  get canCreatePortalLogin(): boolean {
    const loggedIn = JSON.parse(localStorage.getItem('login') || 'false');
    return !!this.pendingRegistration && !loggedIn;
  }

  createPortalLogin() {
    const vendorFormId = localStorage.getItem(PENDING_REGISTRATION_ID_KEY);
    if (!vendorFormId) return;
    this.router.navigate(['/vendor-sign-up'], {
      queryParams: { vendorFormId },
    });
  }

  private handleRegistrationApproved(message?: string) {
    // The edit window has closed, so the stored token can never succeed again.
    this.clearPendingRegistration();

    Swal.fire({
      icon: 'success',
      title: 'Registration Approved',
      text:
        message ||
        'Your registration has been approved and can no longer be edited here.',
      footer: 'Please sign in again to access your full vendor portal.',
      showCancelButton: true,
      confirmButtonText: 'Log out',
      cancelButtonText: 'Stay here',
    }).then((result) => {
      if (result.isConfirmed) {
        clearSessionKeepingBrowserContext();
        localStorage.setItem('login', JSON.stringify(false));
        this.router.navigateByUrl('login');
      }
    });
  }

  private clearPendingRegistration() {
    localStorage.removeItem(PENDING_REGISTRATION_ID_KEY);
    localStorage.removeItem(PENDING_REGISTRATION_TOKEN_KEY);
    this.editMode = false;
    this.showEditBanner = false;
    this.pendingRegistration = null;
    this.editFormId = null;
    this.editToken = null;
    this.existingDocuments = [];
    this.removedDocumentIds = [];
  }

  private prefillAdditionalFields(savedValues: DynamicFormValues[] | undefined) {
    const configurations = this.additionaFields?.dynamicFormConfigurations;
    if (!savedValues?.length || !configurations?.length) return;

    configurations.forEach((config: DynamicFormConfigurationView) => {
      // A File cannot be reconstructed from a stored name; the previously
      // uploaded document stays attached unless the vendor picks a new one.
      if (config.dynamicFormInputTypeId === EDynamicFormInputType.FileInput) {
        return;
      }

      const saved = savedValues.find(
        (value) => value.dynamicFormConfigurationId === config.id,
      );
      if (!saved) return;

      const control = this.form.get(config.tempLabel);
      if (!control) return;

      control.setValue(
        config.dynamicFormInputTypeId === EDynamicFormInputType.Dropdown
          ? saved.dynamicFormConfigurationOptionId
          : saved.value,
      );
    });
  }

  private prefillFromSubmitted(data: any) {
    const radioBooleanControls = new Set([
      'PayViaACH',
      'TradeBusinessEngaged',
      'ReceivesRentOrRoyaltyIncome',
      'IsIncorporated',
      'OfferEarlyPaymentDiscount',
      'isInternational',
    ]);
    const controlToField: { [control: string]: string } = {
      id: 'id',
      Name: 'name',
      LegalName: 'legalName',
      Address: 'address',
      AddressLine2: 'addressLine2',
      isInternational: 'isInternational',
      City: 'city',
      State: 'state',
      country: 'country',
      ZipCode: 'zipCode',
      Description: 'description',
      W9Status: 'w9Status',
      FutureBidStatus: 'futureBidStatus',
      W9StatusReason: 'w9StatusReason',
      VendorType: 'vendorType',
      TradeBusinessEngaged: 'tradeBusinessEngaged',
      ReceivesRentOrRoyaltyIncome: 'receivesRentOrRoyaltyIncome',
      ApplicableTaxIdentificationNumber: 'applicableTaxIdentificationNumber',
      SocialSecurityNumber: 'socialSecurityNumber',
      EmployerIdentificationNumber: 'employerIdentificationNumber',
      Form1099Applicable: 'form1099Applicable',
      paymentType: 'paymentType',
      deliveryMethod: 'deliveryMethod',
      Form1099ApplicableOther: 'form1099ApplicableOther',
      IsIncorporated: 'isIncorporated',
      corporationType: 'corporationType',
      OfferEarlyPaymentDiscount: 'offerEarlyPaymentDiscount',
      EarlyPaymentDiscountDescription: 'earlyPaymentDiscountDescription',
      PayViaACH: 'payViaACH',
      BankName: 'bankName',
      BankRoutingNumber: 'bankRoutingNumber',
      BankAccountNumber: 'bankAccountNumber',
      BankAccountType: 'bankAccountType',
      BankAccountClass: 'bankAccountClass',
      DigitalCheckEmailAddress: 'digitalCheckEmailAddress',
      ProvidesMerchandiseOrUtilities: 'providesMerchandiseOrUtilities',
      MinorityBusinessEnterprise: 'minorityBusinessEnterprise',
      MedicalLegalServicesStatus: 'medicalLegalServicesStatus',
      ExistingBusinessRelation: 'existingBusinessRelation',
      vendorId: 'vendorId',
    };

    Object.keys(controlToField).forEach((controlName) => {
      const control = this.form.get(controlName);
      if (!control) return;
      let value = data[controlToField[controlName]];
      if (value === undefined) return;
      if (radioBooleanControls.has(controlName) && typeof value === 'boolean') {
        value = value.toString();
      }
      control.setValue(value);
    });

    this.item = data;
    this.prefillAdditionalFields(data?.additionalFieldValues);

    const vendorAddresses = this.form.get('vendorAddresses') as FormArray;
    if (data.vendorAddresses?.length) {
      vendorAddresses.clear();
      const sortedAddresses = [...data.vendorAddresses].sort(
        (a: any, b: any) =>
          (b.isDefaultAddress ? 1 : 0) - (a.isDefaultAddress ? 1 : 0),
      );
      sortedAddresses.forEach((address: any) => {
        vendorAddresses.push(
          this.formBuilder.group({
            addressType: [address.addressType],
            address: [address.address],
            addressLine2: [address.addressLine2],
            city: [address.city],
            state: [address.state],
            country: [address.country || 'USA'],
            zipCode: [address.zipCode],
            isInternational: [address.isInternational || false],
            isSameAddress: [address.isSameAddress || false],
            isDefaultAddress: [address.isDefaultAddress || false],
          }),
        );
      });
    }

    this.Contacts = (data.contacts || []).map((contact: any) => ({
      id: contact.id,
      contactName: contact.contactName,
      phone: contact.phone,
      emailAddress: contact.emailAddress,
      contactType: contact.contactType,
    }));
    const contactsFormArray = this.form.get('Contacts') as FormArray;
    contactsFormArray.clear();
    this.Contacts.forEach((contact) => {
      contactsFormArray.push(this.formBuilder.group(contact));
    });

    // Files are already on record from the original submission — do not force re-upload.
    this.setVendorW9FileValidator(this.form.get('W9Status')!.value);
    this.form.get('voidedCheckFile')?.clearValidators();
    this.form.get('voidedCheckFile')?.updateValueAndValidity();
  }

  ngAfterViewInit(): void {}

  get f() {
    return this.form.controls;
  }

  get cf() {
    return this.contactForm.controls;
  }

  onSubmitContent() {
    this.submittedContent = true;
    if (this.contactForm.invalid) {
      this.utilityService.getFormValidationErrors(this.contactForm);
      this.notificationService.showError('Fill all required fields', 'Error');
      return;
    }
    const request = _.cloneDeep(this.contactForm.value);
    const contactFormValue = this.contactForm.value;
    this.Contacts.push(request);
    this.reSetContactForm();
    (this.form.get('Contacts') as FormArray).push(
      this.formBuilder.group(contactFormValue),
    );
  }

  reSetContactForm() {
    this.contactForm.reset();
    this.contactForm
      .get('id')
      ?.setValue('00000000-0000-0000-0000-000000000000');
    this.submittedContent = false;
  }

  resetForm() {
    while (this.filesArray.length) {
      this.filesArray.removeAt(0);
    }
    this.form.reset();
  }

  removeContent(index: number) {
    this.Contacts[index].isDeleted = true;
    const contactsFormArray = this.form.get('Contacts') as FormArray;
    if (contactsFormArray && contactsFormArray.length > index) {
      contactsFormArray.removeAt(index);
    }
    this.Contacts.splice(index, 1);
  }

  integrateAdditionalFields(event: any) {
    const values = event.values;
    if (values && values.length > 0) {
      values.forEach((value: any) => {
        this.form.addControl(
          value.tempLabel,
          new FormControl(value.value, value.validators),
        );
      });
      this.additionaFields = event.dynamicForm;
      this.prefixLabel = event.prefixLabel;

      if (this.isEditing) {
        this.disableAddtionalFields(true);
      }
    }
  }

  onDynamicformFileChange($event: any) {
    const control = this.form.get($event.propertyName);
    if (control) {
      if ($event.file) {
        control.patchValue($event.file);
      }
    } else {
      console.warn(`Form control ${$event.propertyName} not found.`);
    }
  }

  disableAddtionalFields(disable: boolean) {
    Object.keys(this.form.controls).forEach((controlName) => {
      if (controlName.includes(this.prefixLabel)) {
        disable
          ? this.form.controls[controlName].disable()
          : this.form.controls[controlName].enable();
      }
    });
  }

  async onSubmit() {
    this.submitted = true;
    this.updatePurchasingAddressToForm();

    const invalidPostalCodeMessage = this.getInvalidPostalCodeMessage();
    if (invalidPostalCodeMessage) {
      this.notificationService.showError(
        invalidPostalCodeMessage,
        'Invalid Zip/Postal Code',
      );
      return;
    }

    const activeContacts = this.Contacts.filter(
      (contact) => !contact.isDeleted,
    );

    if (activeContacts.length > 0) {
      const contactsFormArray = this.form.get('Contacts') as FormArray;
      if (contactsFormArray) {
        while (contactsFormArray.length !== 0) {
          contactsFormArray.removeAt(0);
        }
        activeContacts.forEach((contact) => {
          const { isDeleted, ...cleanContact } = contact;
          const contactFormGroup = this.formBuilder.group(cleanContact);
          contactsFormArray.push(contactFormGroup);
        });
      }
    } else {
      this.notificationService.showError(
        'Please add at least one contact.',
        'Error',
      );
      return;
    }
    const W9StatusControl = this.form.get('W9Status')?.value; // Retrieve the W9Status value
    const ApplicableTaxIdentificationNumberControl = this.form.get(
      'ApplicableTaxIdentificationNumber',
    );
    const SocialSecurityNumberControl = this.form.get('SocialSecurityNumber');
    const EmployerIdentificationNumberControl = this.form.get(
      'EmployerIdentificationNumber',
    );

    // Clear all validators first to avoid conflicts
    ApplicableTaxIdentificationNumberControl?.clearValidators();
    SocialSecurityNumberControl?.clearValidators();
    EmployerIdentificationNumberControl?.clearValidators();

    // Conditionally set validation based on W9StatusControl
    if (W9StatusControl === 'Yes') {
      // Make ApplicableTaxIdentificationNumber required
      ApplicableTaxIdentificationNumberControl?.setValidators([
        Validators.required,
      ]);

      // Check the selected Tax ID Type
      const taxIdType = ApplicableTaxIdentificationNumberControl?.value;
      if (taxIdType === 'Social Security Number') {
        SocialSecurityNumberControl?.setValidators([Validators.required]);
      } else if (taxIdType === 'Employer Identification Number') {
        EmployerIdentificationNumberControl?.setValidators([
          Validators.required,
        ]);
      }
    }

    // Update validity for all controls
    ApplicableTaxIdentificationNumberControl?.updateValueAndValidity();
    SocialSecurityNumberControl?.updateValueAndValidity();
    EmployerIdentificationNumberControl?.updateValueAndValidity();

    if (this.form.invalid) {
      this.notificationService.showError('Fill all required fields', 'Error');
      return;
    }

    const ssn =
      this.form.get('SocialSecurityNumber')?.value?.replace(/-/g, '') || '';
    this.form.get('SocialSecurityNumber')?.setValue(ssn);
    const ein =
      this.form.get('EmployerIdentificationNumber')?.value?.replace(/-/g, '') ||
      '';
    this.form.get('EmployerIdentificationNumber')?.setValue(ein);

    this.assembleDataforSubmit();
    if (this.form.get('MedicalLegalServicesStatus')?.value === 'Yes') {
      this.form.get('Form1099Applicable')?.setValue('Form 1099-MISC');
    }
    const hasDuplicates = await this.checkForDuplicates();
    if (hasDuplicates) {
      const proceed = await this.showDuplicateVendorsWarning();
      if (!proceed) {
        this.notificationService.showError(
          'Form Submission cancelled.',
          'Cancelled',
        );
        return;
      }
    }
    const request = _.cloneDeep(this.form.value);
    if (this.editMode) {
      request.removedDocumentIds = this.removedDocumentIds;
    }
    let requestCall;
    this.spinner.OnLoading.emit(true);
    requestCall =
      this.editMode && this.editFormId && this.editToken
        ? this.vendorFormService.updateForm(
            this.editFormId,
            this.editToken,
            request,
            this.prefixLabel,
          )
        : this.vendorFormService.createForm(request, this.prefixLabel);
    requestCall.subscribe(
      (data: any) => {
        this.spinner.OnLoading.emit(false);
        if (
          data.confirmation ===
          'There is some issue in saving, please try again later!'
        ) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'There is some issue in saving, please try again later!',
          });
        } else {
          if (!this.editMode && data.vendorFormId && data.editToken) {
            localStorage.setItem(PENDING_REGISTRATION_ID_KEY, data.vendorFormId);
            localStorage.setItem(PENDING_REGISTRATION_TOKEN_KEY, data.editToken);
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Vendor registration is submitted successfully! Create a portal login now to chat with us and track or edit your registration while it awaits approval.',
              showCancelButton: true,
              confirmButtonText: 'Create portal login',
              cancelButtonText: 'Maybe later',
            }).then((result) => {
              if (result.isConfirmed) {
                this.router.navigate(['/vendor-sign-up'], {
                  queryParams: { vendorFormId: data.vendorFormId },
                });
              } else {
                window.location.reload();
              }
            });
            return;
          }
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: this.editMode
              ? 'Your registration changes were submitted successfully!'
              : 'Vendor registration is submitted successfully! You can return to this page to review or edit it until it is approved.',
          }).then(() => {
            window.location.reload();
          });
        }
      },
      (err: any) => {
        this.spinner.OnLoading.emit(false);

        if (err?.status === 409) {
          this.handleRegistrationApproved(err?.error?.message);
          return;
        }

        Swal.fire({
          icon: 'error',
          title: 'Submission Error',
          text:
            err?.error?.message ||
            'An error occurred while submitting the form. Please try again later.',
        });
        console.error('Form submission error:', err);
      },
    );
  }

  assembleDataforSubmit() {
    this.additionaFields?.dynamicFormConfigurations?.forEach(
      (config: DynamicFormConfigurationView) => {
        const value = this.form.get(config.tempLabel)?.value;

        config.value =
          config.dynamicFormInputTypeId === EDynamicFormInputType.FileInput
            ? config.tempLabel.slice(this.prefixLabel.length) +
              '--' +
              value.name
            : value;

        if (config.dynamicFormInputTypeId === EDynamicFormInputType.Dropdown) {
          config.optionId = value;
        }
      },
    );

    this.form.addControl(
      'additionalField',
      this.formBuilder.group({
        source: '',
        sourceId: 1,
        dynamicFormConfigurations: this.formBuilder.array([]),
      }),
    );

    this.additionaFields?.dynamicFormConfigurations?.forEach(
      (config: DynamicFormConfigurationView) => {
        const { dynamicFormConfigurationOptions, ...configWithoutOptions } =
          config;
        (
          this.form.get(
            'additionalField.dynamicFormConfigurations',
          ) as FormArray
        ).push(this.formBuilder.group(configWithoutOptions));
      },
    );
  }

  onAdditionalFileChanged(file: any, i: number) {
    const currentVal = this.filesArray.controls[i].value;
    currentVal.file = file;
    this.filesArray.controls[i].patchValue(currentVal);
  }

  onFileChange($event: any, propertyName: string, maxSizeMB: number) {
    const maxSizeBytes = maxSizeMB * 1024 * 1024; // Convert MB to bytes

    if ($event && $event.size > maxSizeBytes) {
      this.notificationService.showError(
        `File is over the size limit. Please upload a file under ${maxSizeMB}MB.`,
        'Error',
      );
      this.f[propertyName].setValue(null); // Clear the form control
      return;
    }

    this.f[propertyName].setValue($event); // Set the valid file in the form
  }

  get filesArray(): FormArray {
    return this.form.controls['attachments'] as FormArray;
  }

  async onFileSelected(
    event: any,
    fileInput: HTMLInputElement,
  ): Promise<void> {
    const overallMaxSize = 30 * 1024 * 1024; // 30MB in bytes
    const selectedFiles = event.target.files;

    if (!selectedFiles) return;

    // Calculate the current total size of selected files
    let currentTotalSize = this.filesArray.controls.reduce(
      (sum, control) => sum + control.value.file.size,
      0,
    );

    for (const file of selectedFiles) {
      if (this.utilityService.isFileEmptyOrCorrupted(file)) {
        this.notificationService.showError(
          this.utilityService.getCorruptedOrEmptyFileMessage(),
          'Invalid File',
        );
        continue;
      }

      if (!this.utilityService.isFileTypeAllowed(file)) {
        this.notificationService.showError(
          this.utilityService.getUnsupportedFileTypeMessage(file.name),
          'Invalid File Type',
        );
        continue;
      }

      if (file.size > overallMaxSize) {
        this.notificationService.showError(
          `"${file.name}" is over the individual file size limit. Please upload a file under 30MB.`,
          'Error',
        );
        continue;
      }

      // Check if adding this file exceeds the total allowed size
      if (currentTotalSize + file.size > overallMaxSize) {
        const remainingSizeMB = (
          (overallMaxSize - currentTotalSize) /
          (1024 * 1024)
        ).toFixed(2);
        this.notificationService.showError(
          `"${file.name}" cannot be added. You can only upload ${remainingSizeMB}MB more.`,
          'Error',
        );
        continue;
      }

      const restrictedZipMessage =
        await this.utilityService.getRestrictedZipContentMessage(file);
      if (restrictedZipMessage) {
        this.notificationService.showError(
          restrictedZipMessage,
          'Invalid File Type',
        );
        continue;
      }

      // Update total size and add the file
      currentTotalSize += file.size;
      const currentFileCount = this.filesArray.controls.length + 1;
      this.filesArray.push(
        new FormControl({
          label: `File ${currentFileCount}`,
          file,
          order: currentFileCount,
        }),
      );
    }

    fileInput.value = ''; // Reset file input
  }

  get retainedDocuments(): DocumentView[] {
    return this.existingDocuments.filter((doc) => this.removedDocumentIds.indexOf(doc.id) === -1);
  }

  isReplaceableDocument(doc: DocumentView): boolean {
    return doc.documentType === 'vendor W9' || doc.documentType === 'voided Check';
  }

  documentLabel(doc: DocumentView): string {
    if (doc.documentType === 'vendor W9') return 'Vendor W-9';
    if (doc.documentType === 'voided Check') return 'Voided check';
    return 'Additional attachment';
  }

  replacementFor(doc: DocumentView): File | null {
    if (doc.documentType === 'vendor W9') return this.form.get('vendorW9File')?.value || null;
    if (doc.documentType === 'voided Check') return this.form.get('voidedCheckFile')?.value || null;
    return null;
  }

  removeExistingDocument(doc: DocumentView) {
    if (this.isReplaceableDocument(doc) || this.removedDocumentIds.indexOf(doc.id) !== -1) return;
    this.removedDocumentIds = [...this.removedDocumentIds, doc.id];
  }

  removeFile(index: number) {
    if (this.filesArray.controls.length > 0) {
      this.filesArray.removeAt(index);
    }
  }
  createAddress(type: string, isDefault = false): FormGroup {
    return this.formBuilder.group({
      addressType: [type, Validators.required],
      address: [null, [Validators.maxLength(50), Validators.required]],
      addressLine2: [null, Validators.maxLength(50)],
      city: [null, [Validators.maxLength(30), Validators.required]],
      state: ['', [Validators.required]],
      country: ['USA', Validators.required],
      zipCode: [
        null,
        [
          Validators.required,
          Validators.maxLength(10),
          dynamicZipCodeValidator((zipCode: string, country: string) =>
            this.zipCodeService.testZipCode(zipCode, country),
          ),
        ],
      ],
      customerAccountNumber: [null, Validators.maxLength(50)],
      isInternational: [false],
      isSameAddress: [false],
      isDefaultAddress: [isDefault],
    });
  }
  addDefaultAddresses(): void {
    if (!this.id && this.vendorAddress.length === 0) {
      const addresses = this.form.get('vendorAddresses') as FormArray;
      addresses.push(
        this.createAddress(
          vendorAddressAndContactType.Purchasing.toString(),
          true,
        ),
      );
      addresses.push(
        this.createAddress(
          vendorAddressAndContactType.Remittance.toString(),
          true,
        ),
      );
    }
  }
  addAddress(): void {
    const addresses = this.form.get('vendorAddresses') as FormArray;
    addresses.push(this.createAddress(''));
  }
  removeAddress(index: number): void {
    const addresses = this.form.get('vendorAddresses') as FormArray;
    const address = addresses.at(index);
    if (address.get('isDefaultAddress')?.value) {
      this.notificationService.showError(
        'Default addresses cannot be removed.',
        'Error',
      );
      return;
    }
    addresses.removeAt(index);
  }
  getZipCodeMask(index: number): string {
    return this.zipCodeService.getZipCodeMask(this.getAddressCountry(index));
  }
  getZipCodePlaceholder(index: number): string {
    return this.zipCodeService.getZipCodePlaceholder(
      this.getAddressCountry(index),
    );
  }
  getZipCodeTooltip(index: number): string {
    const country = this.getAddressCountry(index);
    if (!country) {
      return "Enter postal code (letters, numbers, spaces and '-' allowed)";
    }
    return `Enter ${this.zipCodeService.getZipCodeDescription(
      country,
    )} (e.g. ${this.zipCodeService.getZipCodePlaceholder(country)})`;
  }
  private getAddressCountry(index: number): string {
    const address = (this.form.get('vendorAddresses') as FormArray).at(index);
    // International addresses use the generic alphanumeric postal code config
    // (letters, digits, spaces, dashes; no mask) regardless of the selected
    // country. Country-specific masks only apply to the domestic US flow.
    if (address?.get('isInternational')?.value) {
      return '';
    }
    return address?.get('country')?.value || 'USA';
  }
  private getInvalidPostalCodeMessage(): string | null {
    const addresses = this.form.get('vendorAddresses') as FormArray;
    const index = addresses.controls.findIndex(
      (address) => address.get('zipCode')?.invalid,
    );
    if (index === -1) {
      return null;
    }
    const zipCode = addresses.at(index).get('zipCode');
    const country = this.getAddressCountry(index);
    if (zipCode?.errors?.['required']) {
      return 'Please enter the zip/postal code.';
    }
    if (!country) {
      return "Please enter a valid postal code (letters, numbers, spaces and '-' allowed).";
    }
    return `Please enter a valid ${this.zipCodeService.getZipCodeDescription(
      country,
    )} (e.g. ${this.zipCodeService.getZipCodePlaceholder(country)}).`;
  }

  onChangeInternationalAddress(index: number) {
    const addresses = this.form.get('vendorAddresses') as FormArray;
    const currentAddress = addresses.at(index);
    const isInternational = !!currentAddress.get('isInternational')?.value;
    if (isInternational) {
      currentAddress
        .get('state')
        ?.setValue(
          this.getSelectedState(currentAddress.get('state')?.value)?.name,
        );
      currentAddress.get('country')?.setValue('');
    } else {
      currentAddress
        .get('state')
        ?.setValue(
          this.getSelectedState(currentAddress.get('state')?.value)
            ?.abbreviation,
        );
      currentAddress.get('country')?.setValue('USA');
    }
    currentAddress.get('zipCode')?.setValue('');
    currentAddress.get('zipCode')?.updateValueAndValidity();
  }
  onCountryChange(index: number): void {
    const addresses = this.form.get('vendorAddresses') as FormArray;
    const currentAddress = addresses.at(index);
    currentAddress.get('zipCode')?.updateValueAndValidity();
  }
  onSameAddressCheck(index: number): void {
    const addresses = this.form.get('vendorAddresses') as FormArray;
    const currentAddress = addresses.at(index);
    if (currentAddress.get('isSameAddress')?.value) {
      const purchasingAddress = addresses.controls.find(
        (addr) =>
          addr.get('addressType')?.value ==
          vendorAddressAndContactType.Purchasing,
      );
      if (purchasingAddress) {
        const isInternational = !!purchasingAddress
          .get('isInternational')
          ?.value;
        currentAddress.get('isInternational')?.setValue(isInternational);
        currentAddress
          .get('country')
          ?.setValue(purchasingAddress.get('country')?.value);
        this.cdr.detectChanges();
        currentAddress
          .get('address')
          ?.setValue(purchasingAddress.get('address')?.value);
        currentAddress
          .get('addressLine2')
          ?.setValue(purchasingAddress.get('addressLine2')?.value);
        currentAddress
          .get('city')
          ?.setValue(purchasingAddress.get('city')?.value);
        currentAddress
          .get('state')
          ?.setValue(purchasingAddress.get('state')?.value);
        currentAddress
          .get('zipCode')
          ?.setValue(purchasingAddress.get('zipCode')?.value);
        currentAddress.get('zipCode')?.updateValueAndValidity();
      } else {
        this.notificationService.showError(
          'No Purchasing address found to set as the same address.',
          'Error',
        );
      }
    } else {
      currentAddress.get('address')?.reset();
      currentAddress.get('addressLine2')?.reset();
      currentAddress.get('city')?.reset();
      currentAddress.get('state')?.reset();
      currentAddress.get('country')?.setValue('USA');
      currentAddress.get('zipCode')?.reset();
      currentAddress.get('zipCode')?.updateValueAndValidity();
    }
  }
  updatePurchasingAddressToForm(): void {
    const addresses = this.form.get('vendorAddresses') as FormArray;
    const purchasingAddress = addresses.controls.find(
      (address) =>
        parseInt(address.get('addressType')?.value, 10) ==
          vendorAddressAndContactType.Purchasing &&
        address.get('isDefaultAddress')?.value,
    );
    if (purchasingAddress) {
      const isInternational = !!purchasingAddress.get('isInternational')?.value;
      this.form
        .get('Address')
        ?.setValue(purchasingAddress.get('address')?.value);
      this.form
        .get('AddressLine2')
        ?.setValue(purchasingAddress.get('addressLine2')?.value);
      this.form.get('City')?.setValue(purchasingAddress.get('city')?.value);
      this.form.get('State')?.setValue(purchasingAddress.get('state')?.value);
      this.form
        .get('country')
        ?.setValue(purchasingAddress.get('country')?.value);
      this.form.get('isInternational')?.setValue(isInternational);
      this.form
        .get('ZipCode')
        ?.setValue(purchasingAddress.get('zipCode')?.value);
    }
  }
  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }
  public getSelectedState(value: string): any {
    if (this.usStates && value) {
      const state: any = this.usStates.find(
        (s) => s.abbreviation == value || s.name == value,
      );
      if (state) {
        return state;
      } else {
        return value;
      }
    }
    return value;
  }
  async checkForDuplicates(): Promise<boolean> {
    const socialSecurityNumber = this.form.get('SocialSecurityNumber')?.value;
    const employerIdentificationNumber = this.form.get(
      'EmployerIdentificationNumber',
    )?.value;
    const id = this.form.get('id')?.value;
    if (!socialSecurityNumber && !employerIdentificationNumber) {
      return false;
    }
    const isDuplicate = await this.vendorFormService
      .checkDuplicateVendors({
        id,
        socialSecurityNumber,
        employerIdentificationNumber,
      })
      .toPromise();
    const hasDuplicates = Boolean(isDuplicate && isDuplicate.length > 0);
    this.form.get('isDuplicate')?.setValue(hasDuplicates);
    return hasDuplicates;
  }
  async showDuplicateVendorsWarning(): Promise<boolean> {
    const result = await Swal.fire({
      icon: 'warning',
      title: 'Possible Duplicate Vendor Found',
      html: `
       <p>
        A vendor with this identification number already exists in <strong>${this.utilityService.clientDisplayName}'s</strong> vendor database.
      </p>
      <p>
        You may proceed with registration, but the client may follow up for additional information.
      </p>
      <p style="font-weight: bold; font-size: 18px;">
        Do you want to proceed with submitting this form?
      </p>
      `,
      width: 800,
      showCancelButton: true,
      confirmButtonText: 'Proceed',
      cancelButtonText: 'Cancel',
      buttonsStyling: true,
    });
    return result.isConfirmed;
  }

  onTINChanged() {
    this.form.get('SocialSecurityNumber')?.setValue('');
    this.form.get('EmployerIdentificationNumber')?.setValue('');
  }

  incorporatedChange() {
    const corporationType = this.form.get('corporationType');
    if (this.form.get('IsIncorporated')?.value === 'Yes') {
      corporationType?.setValidators([Validators.required]);
    } else {
      corporationType?.clearValidators();
      this.form.get('corporationType')?.setValue('');
    }
    corporationType?.updateValueAndValidity();
    this.form1099ApplicableAutoPopulate();
  }

  form1099ApplicableAutoPopulate() {
    if (
      this.form.get('ProvidesMerchandiseOrUtilities')?.value === 'true' ||
      this.form.get('IsIncorporated')?.value === 'Yes'
    ) {
      this.form.get('Form1099Applicable')?.setValue('N/A');
    } else if (
      this.form.get('ReceivesRentOrRoyaltyIncome')?.value === 'Yes' ||
      this.form.get('MedicalLegalServicesStatus')?.value === 'Yes'
    ) {
      this.form.get('Form1099Applicable')?.setValue('Form 1099-MISC');
    } else {
      this.form.get('Form1099Applicable')?.setValue('Form 1099-NEC');
    }
    this.form.get('paymentType')?.setValue('');
  }
  onW9StatusChanged() {
    this.form.get('ApplicableTaxIdentificationNumber')?.setValue('');
    this.form.get('W9StatusReason')?.setValue('');
    this.form.get('SocialSecurityNumber')?.setValue('');
    this.form.get('EmployerIdentificationNumber')?.setValue('');
  }
}
